<template>
    <div
        v-if="posts.length"
        class="blog-grid"
    >
        <div class="blog-posts-wrapper">
            <BlogPostPreview
                v-for="(post, index) in posts"
                :key="post.id"
                :full-width="!index"
                :preview="post"
            />
        </div>

        <suspense suspensible>
            <Pagination
                v-if="totalCount > 10"
                :count="totalCount"
                :current="page"
                :get-route-page="getPageLink"
                :limit
                :range="2"
                scroll-into-view-selector=".blog-header"
            />
        </suspense>
    </div>

    <div
        v-else
        class="empty-state"
    >
        <!-- TODO translate -->
        <p>There are no blog posts for this tag.</p>

        <br />

        <!-- TODO translate -->
        <ThButton
            :to="routes.blog.list()"
            size="small"
        >
            View all blog posts
        </ThButton>
    </div>
</template>

<script lang="ts" setup>
import { useRoutes } from '@/router/routes'
import type { BlogPostPreviewFragment } from '@/graphql/api'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import BlogPostPreview from '@/components/cms/component/blog/BlogPostPreview.vue'
import Pagination from '@/components/ui/Pagination.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'

defineProps<{
    posts: BlogPostPreviewFragment[]
    getPageLink: (page: number) => ButtonRouteRelative
    page: number
    totalCount: number
    limit: number
}>()

const routes = useRoutes()
</script>

<style lang="scss" scoped>
.blog-posts-wrapper {
    width: 1140px;
    max-width: 100%;
    margin: 0 auto 60px;
    padding: 0 0 20px;
    @include border-bottom;

    @include min-width(640) {
        padding: 0 20px 20px;
    }

    @include min-width(1024) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 30px;
    }

    @include min-width(1140) {
        padding: 0 0 20px;
    }
}

.empty-state {
    width: 1140px;
    margin: 0 auto;
    padding: 100px 0 150px;
    text-align: center;
}
</style>
